import { render } from "./PartnerShippingDashboard.vue?vue&type=template&id=7c9bb21a&scoped=true"
import script from "./PartnerShippingDashboard.vue?vue&type=script&lang=js"
export * from "./PartnerShippingDashboard.vue?vue&type=script&lang=js"

import "./PartnerShippingDashboard.vue?vue&type=style&index=0&id=7c9bb21a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c9bb21a"]])

export default __exports__